import { isEmpty } from 'lodash';

export default function addUnitToAddress(address: string, unit: string) {
  if (isEmpty(address)) {
    return '';
  }
  if (isEmpty(unit)) {
    return address;
  }

  const parts = address.split(',');
  parts.splice(1, 0, ` ${unit}`);
  return parts.join(',');
}
